import React from "react";
import { useNavigate } from "react-router-dom";

const StudioInterviewCard: React.FC = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/content-interviews");
  };

  return (
    <div className="studio-interview-card" onClick={handleClick}>
      <div>
        <h3 className="studio-interview-title">
          Interview <span style={{ fontSize: "12px", fontWeight: 500, color: "#6366F1" }}>(new)</span>
        </h3>
        <p className="studio-interview-description">
          Chat with either AI or our team, and we will create content based off of it.
        </p>
      </div>
      
      <div className="studio-interview-placeholders">
        {[1, 2, 3, 4, 5].map((i) => (
          <div 
            key={i}
            className="studio-interview-placeholder"
          />
        ))}
      </div>
    </div>
  );
};

export default StudioInterviewCard;
